import { useApolloClient } from '@apollo/client';
import { useCallback } from 'react';
import {
    ValidateFileDocument,
    type ValidateFileQuery,
    type ValidateFileQueryVariables,
} from '../../../api/queries/validateFile';
import { type FormValues } from '../AddVehiclePage/AddVariantPage/types';

const useVariantAssetValidation = () => {
    const apolloClient = useApolloClient();

    return useCallback(
        async (values: FormValues) => {
            /* Only checking the new uploaded files */

            const { images, brochure } = values;

            if (images) {
                await Promise.all(
                    images.map(image => {
                        if (image instanceof File) {
                            return apolloClient.query<ValidateFileQuery, ValidateFileQueryVariables>({
                                query: ValidateFileDocument,
                                fetchPolicy: 'cache-first',
                                variables: { upload: image, assetFieldSource: 'images' },
                            });
                        }

                        return null;
                    })
                );
            }

            if (brochure && brochure instanceof File) {
                await Promise.resolve(
                    apolloClient.query<ValidateFileQuery, ValidateFileQueryVariables>({
                        query: ValidateFileDocument,
                        fetchPolicy: 'cache-first',
                        variables: { upload: brochure, assetFieldSource: 'brochure' },
                    })
                );
            }
        },
        [apolloClient]
    );
};

export default useVariantAssetValidation;
